var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn', _vm.customStyle],attrs:{"type":"button"}},[_c('i',{class:[_vm.iconClass, 'bx-xs']})])}
var staticRenderFns = []

export { render, staticRenderFns }